import { CommonModule } from '@angular/common';
import { Component, inject, input, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DividerModule } from 'primeng/divider';

import { ChatMessageContentComponent } from '@offconon/shared/features/chat/chat-message-content';
import { ChatMessageHeaderComponent } from '@offconon/shared/features/chat/chat-message-header';
import { ChatMessageInputComponent } from '@offconon/shared/features/chat/chat-message-input';
import { DesignPanelsHelperService } from '@offconon/shared/utils/services/design-panels-helper';

@Component({
  selector: 'offconon-chat-message-body',
  imports: [
    CommonModule,
    TranslateModule,
    DividerModule,
    ChatMessageContentComponent,
    ChatMessageHeaderComponent,
    ChatMessageInputComponent,
    MatIcon,
  ],
  styles: ``,
  template: ` <div
    class="flex flex-col !h-[calc(100dvh-var(--layout-header-height)-var(--chat-gap))]">
    <div class="flex-initial flex flex-row items-center gap-2">
      @if (view_type === 'widget') {
        <div class="flex cursor-pointer opacity-50 hover:opacity-100 text-xs" (click)="close()">
          <mat-icon style="height: initial; width: initial">keyboard_backspace</mat-icon>
        </div>
      }
      <div class="text-sm font-bold mb-3">
        {{ 'Chat' | translate }}
      </div>
    </div>
    <div class="flex-initial">
      <offconon-chat-message-header
        [roomId]="roomId()"
        [platform]="platform"
        [selectedBusiness]="selectedBusiness"
        [parameters]="parameters"
        [logged_user]="logged_user" />
    </div>
    <div class="flex-1 overflow-auto">
      <offconon-chat-message-content [roomId]="roomId()" />
    </div>
    <div class="flex-initial">
      <offconon-chat-message-input [roomId]="roomId()" />
    </div>
  </div>`,
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageBodyComponent implements OnInit {
  @Input() logged_user: any;
  @Input() selectedBusiness: any;
  @Input() parameters: any;
  @Input() platform = 'core';
  roomId = input.required<number>();
  private designPanelsHelperService = inject(DesignPanelsHelperService);

  view_type: any;
  selectedRoomMessages: any;
  rcToken: any;
  unread = 0;
  rid: any;

  ngOnInit() {
    this.view_type = this.parameters?.view_type;
  }

  close() {
    this.designPanelsHelperService.setSelectedModuleEnum('chatlist');
  }
}
